import { configureStore, combineReducers } from "@reduxjs/toolkit";

import batchesReducer from "./slices/batchesSlice";
import uploadsReducer from "./slices/uploadsSlice";
import selectedBatchReducer from "./slices/selectedBatchSlice";
import currentQueueReducer from "./slices/currentQueueSlice";
import uploadApprovalReducer from "./slices/uploadApprovalSlice";
import uploadFooterActionsReducer from "./slices/uploadFooterActionsSlice";
import largeImageViewReducer from "./slices/largeImageViewSlice";
import animationsSliceReducer from "./slices/animationsSlice";
import messagesSliceReducer from "./slices/messagesSlice";

// Middleware
import uploadEnhancer from "./middleware/uploadEnhancer";
// import actionLogger from "./middleware/actionLogger"; // use during dev to log Redux action details

import { REDUCERS } from "./constants";

export const photoModReducer = combineReducers({
    [REDUCERS.BATCHES]: batchesReducer,
    [REDUCERS.UPLOADS]: uploadsReducer,
    [REDUCERS.SELECTED_BATCH]: selectedBatchReducer,
    [REDUCERS.CURRENT_QUEUE]: currentQueueReducer,
    [REDUCERS.UPLOAD_APPROVAL]: uploadApprovalReducer,
    [REDUCERS.UPLOAD_FOOTER_ACTIONS]: uploadFooterActionsReducer,
    [REDUCERS.LARGE_IMAGE_VIEW]: largeImageViewReducer,
    [REDUCERS.ANIMATIONS]: animationsSliceReducer,
    [REDUCERS.MESSAGES]: messagesSliceReducer
});

export const photoModMiddleware = [
    // batchMiddleware,
    uploadEnhancer
    // actionLogger
];

const photoModStore = configureStore({
    reducer: photoModReducer,
    middleware: photoModMiddleware
});

export default photoModStore;
